import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../AuthContext';

const API_URL = process.env.REACT_APP_API_URL;

const ShareBundleRedirect = () => {

  const { id } = useParams(); // short code
    const navigate = useNavigate();
    const { loggedIn } = useAuth();
  
    const [originalUrl, setOriginalUrl] = useState('');
    const [loading, setLoading] = useState(true);
  
    useEffect(() => {
      // Wait for auth status to be resolved
      if (loggedIn === null) return;
  
      // Fetch the original URL from backend
      const fetchOriginalUrl = async () => {
        try {
          const res = await fetch(`${API_URL}/api/get_original_url/${id}/`);
          if (!res.ok) throw new Error('Failed to fetch URL');
          const data = await res.json();
          setOriginalUrl(`/bundle-detail/${data.id}`);
        } catch (err) {
          console.error(err);
          // Redirect to a safe fallback, e.g., homepage
          navigate('/', { replace: true });
        } finally {
          setLoading(false);
        }
      };
  
      fetchOriginalUrl();
    }, [loggedIn, id, navigate]);
  
    useEffect(() => {
      if (loading || !originalUrl) return;
  
      // Redirect based on login status
      if (loggedIn) {
        navigate(originalUrl, { replace: true });
      } else {
        navigate(`/login?redirect=${encodeURIComponent(originalUrl)}`, { replace: true });
      }
    }, [loading, originalUrl, loggedIn, navigate]);
  
    return null; // No UI needed
  };

export default ShareBundleRedirect;
